<template>
  <a-layout class="layout">
    <a-layout-header :style="{ position: 'fixed', width: '100%' }">

      <!-- 非会员可搜索nav -->
      <NavigationBarNonMember @updatePage="handleUpdatePage" @updateIdentity="handleUpdateIdentity"
        v-if="currentIdentity == 'nonmember'" :path='nowPath' />

      <!-- 用户登录nav -->
      <NavigationBarNonMember1 @updatePage="handleUpdatePage" @updateIdentity="handleUpdateIdentity"
        v-else-if="currentIdentity == 'login'" />

      <!-- 登录后nav -->
      <NavigationBarMember v-model:currentPage="currentPage" @updatePage="handleUpdatePage" :name="nowName"
        @updateIdentity="handleUpdateIdentity" v-else-if="currentIdentity == 'member'" />
      <NavigationBarMember3 v-model:currentPage="currentPage" @updatePage="handleUpdatePage" :name="nowName"
        @updateIdentity="handleUpdateIdentity" v-else-if="currentIdentity == 'meinfo'" />

      <!-- 初次登录提交文件nav -->
      <NavigationBarMember1 v-else-if="currentIdentity == 'firstloginin' && currentPage != 'welcome'" />
      <NavigationBarMember2 v-else-if="currentIdentity == 'firstloginin' && currentPage == 'welcome'" />
    </a-layout-header>
    <a-layout-content>
      <router-view :current-page="currentPage"></router-view>
    </a-layout-content>
  </a-layout>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import NavigationBarMember from './components/NavigationBar/NavigationBarMember.vue';
import NavigationBarMember1 from './components/NavigationBar/NavigationBarMember1.vue';
import NavigationBarMember2 from './components/NavigationBar/NavigationBarMember2.vue';
import NavigationBarMember3 from './components/NavigationBar/NavigationBarMember3.vue';
import NavigationBarNonMember from './components/NavigationBar/NavigationBarNonMember.vue';
import NavigationBarNonMember1 from './components/NavigationBar/NavigationBarNonMember1.vue';
import { useRoute } from 'vue-router';
import { useStore } from '@/stores/useStores'
import Api from '@/utils/api'
const route = useRoute()
const currentPage = ref('home')
const currentIdentity = ref('nonmember')
const handleUpdatePage = (newPage) => {
  currentPage.value = newPage
}


const handleUpdateIdentity = (newIdentity) => {
  currentIdentity.value = newIdentity
  // router.push(newIdentity)
  console.log('hahaah', newIdentity)
  if (newIdentity === 'login') {
    currentPage.value = 'login'
    currentIdentity.value = 'login'
  } else if (newIdentity === 'firstloginin') {
    currentPage.value = 'firstwritepeople'
  } else if (newIdentity === 'member1') {
    currentIdentity.value = 'member'
    currentPage.value = 'score'
  }
}
// const nowPhone = ref(localStorage.getItem('phone'))
const nowName = ref(localStorage.getItem('name'))
const nowPath = ref()
watch(
  () => route,
  (newRoute) => {
    const { query, path } = newRoute
    nowPath.value = path.replace(/^\//, '') || 'home';

    // 优先根据 query 设置身份和页面
    if (query.currentIdentity) {
      currentIdentity.value = query.currentIdentity
    } else {
      currentIdentity.value = 'nonmember'
    }

    if (query.currentPage) {
      currentPage.value = query.currentPage
    } else {
      // 如果没有 query.currentPage，再根据 path 设置
      if (path == '/memberhome') {
        currentPage.value = 'board'
      } else if (path == '/esgRating') {
        currentPage.value = 'score'
      } else if (path == '/esgGrade') {
        currentPage.value = 'grade'
      } else if (path == '/evaFile' && (query.pot == '1' || query.pot == undefined || query.pot == null)) {
        console.log(111)
        currentPage.value = 'file1'
      } else if (path == '/evaFile' && query.pot == '2') {
        currentPage.value = 'file2'
      } else if (path == '/evaFile' && query.pot == '3') {
        currentPage.value = 'file3'
      } else if (path == '/evaImprove') {
        currentPage.value = 'improve'
      } else if (path == '/training') {
        currentPage.value = 'course'
      } else if (path == '/esgReg') {
        currentPage.value = 'customized'
      } else if (path == '/report') {
        currentPage.value = 'report'
      } else if (path == '/userInfo') {
        currentPage.value = 'user'
      } else if (path == '/companyInfo') {
        currentPage.value = 'company'
      } else if (path == '/changePhone') {
        currentPage.value = 'changePhone'
      } else if (path == '/login') {
        currentPage.value = 'loginout'
      }
    }
    console.log(localStorage.getItem('phone'))
    nowName.value = localStorage.getItem('name')
  },
  { immediate: true, deep: true }
)

const store = useStore()
onMounted(async () => {
  store.fetchUserData()
  await Api.getUserInfo()
})
</script>

<style scoped>
#app {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

.ant-layout {
  overflow: hidden;
}

.ant-layout-header {
  background-color: transparent;
  height: auto;
  z-index: 99;
  padding: 0;
}

.ant-layout-content {
  height: auto;
  min-height: 100vh;
  padding: 0;
}

.mainPage {
  height: 100vh;
  width: 100%;
}

.site-layout-content {
  min-height: 280px;
  padding: 24px;
  background: #fff;
}

#components-layout-demo-top .logo {
  float: left;
  width: 120px;
  height: 31px;
  margin: 16px 24px 16px 0;
  background: rgba(255, 255, 255, 0.3);
}

.ant-row-rtl #components-layout-demo-top .logo {
  float: right;
  margin: 16px 0 16px 24px;
}

[data-theme='dark'] .site-layout-content {
  background: #141414;
}
</style>
<style>
* {
  font-family: Source Han Sans CN;
}

.ant-input-affix-wrapper:focus,
.ant-input-affix-wrapper-focused,
.ant-input:focus,
.ant-input-focused {
  border-color: #26734C !important;
  box-shadow: 0 0 0 2px #D4EDE0 !important;
}

.ant-input-password:focus,
.ant-input-password-focused {
  border-color: #26734C !important;
  box-shadow: 0 0 0 2px #D4EDE0 !important;
}

.ant-input:hover,
.ant-input-affix-wrapper:hover {
  border-color: #26734C !important;
}

/* 修改密码输入框的悬停边框颜色 */
.ant-input-password:hover {
  border-color: #26734C !important;
}

/* 懒加载样式 */

/* 懒加载图片占位样式 */
.lazy-image {
  background: linear-gradient(90deg,
      #f8f9fa 0%,
      #e9ecef 25%,
      #f8f9fa 50%,
      #e9ecef 75%,
      #f8f9fa 100%);
  background-image: linear-gradient(90deg, #f8f9fa 0%, #e9ecef 50%, #f8f9fa 100%);
  background-size: 400% 100%;

  /* 确保有最小高度 */
  height: 100%;


  /* 加载动画 */
  position: relative;
  overflow: hidden;
}

.lazy-image.lazy-loading {
  animation: skeleton-wave 2.5s ease-in-out infinite;
}

/* 加载中的闪烁动画 */
.lazy-image.lazy-loading::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.3);
  /* 降低透明度 */
  animation: gentle-shine 2s ease-in-out infinite;
}

/* 加载完成的状态 */
.lazy-image.loaded {
  background: none;
  height: auto;
}

.lazy-image.loaded::before {
  display: none;
}

/* 错误状态 */
.lazy-image.lazy-error {
  background: #ffe6e6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lazy-image.lazy-error::after {
  content: '图片加载失败';
  color: #ff4757;
  font-size: 14px;
  font-weight: 500;
}

/* 图片显示动画 */
.lazy-image[src] {
  opacity: 0;
  transition: opacity 2.5s ease;
}

.lazy-image.loaded[src] {
  opacity: 1;
}

/* 加载动画 */
@keyframes skeleton-wave {
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: -100% 50%;
  }
}
</style>
